module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"previousDay":"Previous Day","nextDay":"Next Day","hour":"h"}}')
  delete Component.options._Ctor
}
